import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'infra-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './infra-menu.component.html',
  styleUrls: ['./infra-menu.component.css'],
})
export class InfraMenuComponent {

}
